// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MIDI Player Button Styles */
.midi-play-btn {
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    transition: background-color 0.3s ease;
}
.midi-play-btn:hover:not(:disabled) {
    background-color: #0056b3;
}
.midi-play-btn:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.midi-stop-btn {
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    transition: background-color 0.3s ease;
}
.midi-stop-btn:hover:not(:disabled) {
    background-color: #c82333;
}
.midi-stop-btn:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}
/* File Widget Styles */
.file-widget {
    margin-bottom: 20px;
}

.drop-zone {
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
    margin-bottom: 15px;
}

.drop-zone.drag-over {
    border-color: #007bff;
    background-color: #e3f2fd;
    transform: scale(1.02);
}

.drop-zone-content {
    color: #6c757d;
}

.drop-zone-content p {
    margin: 5px 0;
    font-size: 16px;
}

.file-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 10px;
}

.file-button:hover {
    background-color: #0056b3;
}

.file-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.file-info {
    margin-top: 15px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #007bff;
}

.file-details {
    font-family: monospace;
    font-size: 14px;
    color: #495057;
}

/* MIDI Visualizer Styles */
.midi-visualizer {
    margin: 20px 0;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    overflow: hidden;
    background-color: #f8f9fa;
}

/* Original MIDI Grid Styles (from median.css) */
div.midigrid {
    position: relative;
    background-color: #E8E8E0;
    overflow: hidden;
    cursor: default;
    border: 1px solid #ccc;
    min-height: 60px;
}

div.midiitem {
    position: absolute;
    height: 4px;
    background-color: black;
    user-select: none;
    border: none;
}

div.selbox {
    background-color: gray;
    position: absolute;
    opacity: 0.2;
    pointer-events: none;
}

/* Track Component Styles */
.track-component {
    margin: 20px 0;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
}

.track-component.empty {
    padding: 20px;
    text-align: center;
    color: #6c757d;
}

.track-header {
    background-color: #f8f9fa;
    padding: 15px 20px;
    border-bottom: 1px solid #dee2e6;
}

.track-header h3 {
    margin: 0 0 10px 0;
    color: #495057;
}

.track-name {
    font-weight: normal;
    color: #6c757d;
}

.track-stats {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.stat {
    font-size: 14px;
    color: #6c757d;
    background-color: #e9ecef;
    padding: 4px 8px;
    border-radius: 4px;
}

.track-content {
    padding: 0;
}

.track-controls {
    padding: 15px 20px;
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
}

.selection-info {
    margin-bottom: 15px;
    font-size: 14px;
    color: #6c757d;
}

.action-buttons {
    display: flex;
    gap: 10px;
    align-items: center;
}

.mpc-button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.mpc-button:hover:not(:disabled) {
    background-color: #218838;
}

.mpc-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

.clear-selection-button {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.clear-selection-button:hover {
    background-color: #5a6268;
}

.empty-track {
    padding: 40px 20px;
    text-align: center;
    color: #6c757d;
    font-style: italic;
}

/* MIDI Header Styles */
.midi-header {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #007bff;
}

.midi-header h2 {
    margin: 0 0 15px 0;
    color: #495057;
}

.header-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 10px;
}

.header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
    border-bottom: 1px solid #dee2e6;
}

.header-row:last-child {
    border-bottom: none;
}

.label {
    font-weight: 600;
    color: #495057;
}

.value {
    color: #6c757d;
    font-family: monospace;
}

/* Main App Styles */
.midi-converter-app {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.app-header {
    text-align: center;
    margin-bottom: 40px;
}

.app-header h1 {
    color: #495057;
    margin-bottom: 10px;
}

.app-description {
    color: #6c757d;
    font-size: 16px;
    line-height: 1.5;
    max-width: 800px;
    margin: 0 auto;
}

.file-section {
    margin-bottom: 30px;
}

.loading-section {
    text-align: center;
    padding: 60px 20px;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.error-section {
    margin: 30px 0;
}

.error-message {
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
    padding: 20px;
    border-radius: 6px;
    text-align: center;
}

.error-message h3 {
    margin: 0 0 10px 0;
    color: #721c24;
}

.error-message button {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
}

.error-message button:hover {
    background-color: #c82333;
}

.midi-content {
    margin-top: 30px;
}

.content-header {
    margin-bottom: 30px;
}

.midi-stats {
    margin: 20px 0;
    padding: 15px;
    background-color: #e3f2fd;
    border-radius: 6px;
}

.stats-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
}

.stat-item {
    padding: 8px 12px;
    background-color: white;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #495057;
}

.content-controls {
    text-align: center;
    margin: 20px 0;
}

.clear-button {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.clear-button:hover {
    background-color: #5a6268;
}

.track-list {
    margin: 30px 0;
}

.usage-notes {
    margin-top: 40px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #28a745;
}

.usage-notes h3 {
    margin: 0 0 15px 0;
    color: #495057;
}

.usage-notes ul {
    color: #6c757d;
    line-height: 1.6;
}

.usage-notes li {
    margin-bottom: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .midi-converter-app {
        padding: 15px;
    }
    
    .header-info {
        grid-template-columns: 1fr;
    }
    
    .track-stats {
        flex-direction: column;
        gap: 8px;
    }
    
    .stats-row {
        flex-direction: column;
        align-items: center;
        gap: 8px;
    }
    
    .action-buttons {
        flex-direction: column;
        align-items: stretch;
    }
    
    .zoom-controls {
        margin-bottom: 10px;
    }
    
    .visualizer-controls {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }
}

@media (max-width: 480px) {
    .drop-zone {
        padding: 30px 15px;
    }
    
    .drop-zone-content p {
        font-size: 14px;
    }
    
    .track-header {
        padding: 12px 15px;
    }
    
    .track-controls {
        padding: 12px 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA,uBAAuB;AACvB;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,gDAAgD;AAChD;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA,2BAA2B;AAC3B;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8EAA8E;AAClF;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* MIDI Player Button Styles */\n.midi-play-btn {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-weight: 600;\n    transition: background-color 0.3s ease;\n}\n.midi-play-btn:hover:not(:disabled) {\n    background-color: #0056b3;\n}\n.midi-play-btn:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n\n.midi-stop-btn {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-weight: 600;\n    transition: background-color 0.3s ease;\n}\n.midi-stop-btn:hover:not(:disabled) {\n    background-color: #c82333;\n}\n.midi-stop-btn:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n/* File Widget Styles */\n.file-widget {\n    margin-bottom: 20px;\n}\n\n.drop-zone {\n    border: 2px dashed #dee2e6;\n    border-radius: 8px;\n    padding: 40px 20px;\n    text-align: center;\n    background-color: #f8f9fa;\n    transition: all 0.3s ease;\n    margin-bottom: 15px;\n}\n\n.drop-zone.drag-over {\n    border-color: #007bff;\n    background-color: #e3f2fd;\n    transform: scale(1.02);\n}\n\n.drop-zone-content {\n    color: #6c757d;\n}\n\n.drop-zone-content p {\n    margin: 5px 0;\n    font-size: 16px;\n}\n\n.file-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 6px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-top: 10px;\n}\n\n.file-button:hover {\n    background-color: #0056b3;\n}\n\n.file-button:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n\n.file-info {\n    margin-top: 15px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    border-left: 4px solid #007bff;\n}\n\n.file-details {\n    font-family: monospace;\n    font-size: 14px;\n    color: #495057;\n}\n\n/* MIDI Visualizer Styles */\n.midi-visualizer {\n    margin: 20px 0;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    overflow: hidden;\n    background-color: #f8f9fa;\n}\n\n/* Original MIDI Grid Styles (from median.css) */\ndiv.midigrid {\n    position: relative;\n    background-color: #E8E8E0;\n    overflow: hidden;\n    cursor: default;\n    border: 1px solid #ccc;\n    min-height: 60px;\n}\n\ndiv.midiitem {\n    position: absolute;\n    height: 4px;\n    background-color: black;\n    user-select: none;\n    border: none;\n}\n\ndiv.selbox {\n    background-color: gray;\n    position: absolute;\n    opacity: 0.2;\n    pointer-events: none;\n}\n\n/* Track Component Styles */\n.track-component {\n    margin: 20px 0;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.track-component.empty {\n    padding: 20px;\n    text-align: center;\n    color: #6c757d;\n}\n\n.track-header {\n    background-color: #f8f9fa;\n    padding: 15px 20px;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.track-header h3 {\n    margin: 0 0 10px 0;\n    color: #495057;\n}\n\n.track-name {\n    font-weight: normal;\n    color: #6c757d;\n}\n\n.track-stats {\n    display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.stat {\n    font-size: 14px;\n    color: #6c757d;\n    background-color: #e9ecef;\n    padding: 4px 8px;\n    border-radius: 4px;\n}\n\n.track-content {\n    padding: 0;\n}\n\n.track-controls {\n    padding: 15px 20px;\n    background-color: #f8f9fa;\n    border-top: 1px solid #dee2e6;\n}\n\n.selection-info {\n    margin-bottom: 15px;\n    font-size: 14px;\n    color: #6c757d;\n}\n\n.action-buttons {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.mpc-button {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.mpc-button:hover:not(:disabled) {\n    background-color: #218838;\n}\n\n.mpc-button:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n}\n\n.clear-selection-button {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.clear-selection-button:hover {\n    background-color: #5a6268;\n}\n\n.empty-track {\n    padding: 40px 20px;\n    text-align: center;\n    color: #6c757d;\n    font-style: italic;\n}\n\n/* MIDI Header Styles */\n.midi-header {\n    margin-bottom: 20px;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    border-left: 4px solid #007bff;\n}\n\n.midi-header h2 {\n    margin: 0 0 15px 0;\n    color: #495057;\n}\n\n.header-info {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 10px;\n}\n\n.header-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 0;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.header-row:last-child {\n    border-bottom: none;\n}\n\n.label {\n    font-weight: 600;\n    color: #495057;\n}\n\n.value {\n    color: #6c757d;\n    font-family: monospace;\n}\n\n/* Main App Styles */\n.midi-converter-app {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.app-header {\n    text-align: center;\n    margin-bottom: 40px;\n}\n\n.app-header h1 {\n    color: #495057;\n    margin-bottom: 10px;\n}\n\n.app-description {\n    color: #6c757d;\n    font-size: 16px;\n    line-height: 1.5;\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.file-section {\n    margin-bottom: 30px;\n}\n\n.loading-section {\n    text-align: center;\n    padding: 60px 20px;\n}\n\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #007bff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 0 auto 20px;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.error-section {\n    margin: 30px 0;\n}\n\n.error-message {\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    color: #721c24;\n    padding: 20px;\n    border-radius: 6px;\n    text-align: center;\n}\n\n.error-message h3 {\n    margin: 0 0 10px 0;\n    color: #721c24;\n}\n\n.error-message button {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 10px;\n}\n\n.error-message button:hover {\n    background-color: #c82333;\n}\n\n.midi-content {\n    margin-top: 30px;\n}\n\n.content-header {\n    margin-bottom: 30px;\n}\n\n.midi-stats {\n    margin: 20px 0;\n    padding: 15px;\n    background-color: #e3f2fd;\n    border-radius: 6px;\n}\n\n.stats-row {\n    display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.stat-item {\n    padding: 8px 12px;\n    background-color: white;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #495057;\n}\n\n.content-controls {\n    text-align: center;\n    margin: 20px 0;\n}\n\n.clear-button {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.clear-button:hover {\n    background-color: #5a6268;\n}\n\n.track-list {\n    margin: 30px 0;\n}\n\n.usage-notes {\n    margin-top: 40px;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    border-left: 4px solid #28a745;\n}\n\n.usage-notes h3 {\n    margin: 0 0 15px 0;\n    color: #495057;\n}\n\n.usage-notes ul {\n    color: #6c757d;\n    line-height: 1.6;\n}\n\n.usage-notes li {\n    margin-bottom: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .midi-converter-app {\n        padding: 15px;\n    }\n    \n    .header-info {\n        grid-template-columns: 1fr;\n    }\n    \n    .track-stats {\n        flex-direction: column;\n        gap: 8px;\n    }\n    \n    .stats-row {\n        flex-direction: column;\n        align-items: center;\n        gap: 8px;\n    }\n    \n    .action-buttons {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .zoom-controls {\n        margin-bottom: 10px;\n    }\n    \n    .visualizer-controls {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    .drop-zone {\n        padding: 30px 15px;\n    }\n    \n    .drop-zone-content p {\n        font-size: 14px;\n    }\n    \n    .track-header {\n        padding: 12px 15px;\n    }\n    \n    .track-controls {\n        padding: 12px 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
